export default __webpack_public_path__ + "static/media/Upload.5327a04a.png";